import { FormlyForm } from "@ngx-formly/core"
import { ApiService } from "../services/api.service";
import { filter, switchMap, take, tap } from "rxjs/operators";
import { BehaviorSubject, Observable, Subject, of } from "rxjs";

// ─── PPA Dropdown Options Cache Helpers ───────────────────────────────────────
const PPA_DROPDOWN_CACHE_KEY = 'ppa_dropdown_options';
const PPA_DROPDOWN_TTL_MS = 8 * 60 * 60 * 1000; // 8 hours

interface PpaDropdownCache {
  data: any;
  timestamp: number;
}

/** Returns cached dropdown data if it exists and is within the TTL, otherwise null. */
export function getPpaDropdownOptionsCache(): any | null {
  try {
    const raw = localStorage.getItem(PPA_DROPDOWN_CACHE_KEY);
    if (!raw) return null;
    const entry: PpaDropdownCache = JSON.parse(raw);
    if (!entry || !entry.data || !entry.timestamp) return null;
    if (Date.now() - entry.timestamp > PPA_DROPDOWN_TTL_MS) {
      localStorage.removeItem(PPA_DROPDOWN_CACHE_KEY);
      return null;
    }
    return entry.data;
  } catch {
    return null;
  }
}

/** Stores dropdown data with a timestamp for TTL tracking. */
export function setPpaDropdownOptionsCache(data: any): void {
  const entry: PpaDropdownCache = { data, timestamp: Date.now() };
  localStorage.setItem(PPA_DROPDOWN_CACHE_KEY, JSON.stringify(entry));
}

/** Removes the dropdown options cache, forcing a fresh fetch on next access. */
export function invalidatePpaDropdownOptionsCache(): void {
  localStorage.removeItem(PPA_DROPDOWN_CACHE_KEY);
}
// ──────────────────────────────────────────────────────────────────────────────

export function TOOLTIPS_DATA(apiService?: ApiService): any {
  if (apiService) {
    apiService.GetTooltips().subscribe((res: any) => {
      if (res) {
        apiService.updateTooltipData(res.toolTipsData);
      }
    })
  } else {
    // Handle the case when ApiService is not provided
    console.log('ApiService is not provided');
    return of(null); // Return an empty observable or handle the error case accordingly
  }
}

export interface StorageLike {
  get(key: string): any;
  set(key: string, value: any): any;
}

export function PPA_DROPDOWN_OPTIONS(apiService: ApiService, localStorage: StorageLike): any {
	if (apiService) {
		const data = getPpaDropdownOptionsCache();
		if (!data) {
			apiService.GetPPA_DROPDOWN_OPTIONS().subscribe((res: any) => {
				setPpaDropdownOptionsCache(res);
			});
		}
	} else {
	  // Handle the case when ApiService is not provided
	  console.log('ApiService is not provided');
	  return of(null); // Return an empty observable or handle the error case accordingly
	}
  }

export const ConverterOptions = [
	{
		"name" : "CSV DE",
		"columnSeparator" : ";",
		"decimalSeparator" : ",",
	},
	{
		"name" : "CSV EN",
		"columnSeparator" : ",",
		"decimalSeparator" : ".",
	},
	{
		"name" : "TSV DE",
		"columnSeparator" : "\t",
		"decimalSeparator" : ",",
	},
	{
		"name" : "TSV EN",
		"columnSeparator" : "\t",
		"decimalSeparator" : ".",
	}	
]

